function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M11.51 23.5H2.12A1.62 1.62 0 0 0 .5 25.12v3.76c0 .895.725 1.62 1.62 1.62h12.162a11.454 11.454 0 0 1-2.771-7zm.904-5a11.504 11.504 0 0 1 9.77-6.971 1.627 1.627 0 0 0-.304-.029H2.12A1.62 1.62 0 0 0 .5 13.12v3.76c0 .895.725 1.62 1.62 1.62h10.294zM21.88.5H2.12A1.62 1.62 0 0 0 .5 2.12v3.76c0 .895.725 1.62 1.62 1.62h19.76a1.62 1.62 0 0 0 1.62-1.62V2.12A1.62 1.62 0 0 0 21.88.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 8.5,
  fill: "url(#b)",
  fillRule: "nonzero",
  stroke: "#BEBFCB"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7B8E",
  d: "M13.2 28H7a1 1 0 0 1 0-2l5.414.001c.198.697.462 1.366.786 2zm1.314-12H7a1 1 0 0 1 0-2h9.674a11.063 11.063 0 0 0-2.16 2zM17 3a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2h10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M4 24v6H2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2zM4 1v6H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2zM23 19a1 1 0 0 1 1 1v2.036l3.037-1.781a.993.993 0 0 1 1.359.354l.002.003.005.008a1 1 0 0 1-.36 1.363l-5.05 2.96a.663.663 0 0 1-.998-.572v-.585L22 23.69V20a1 1 0 0 1 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D01E29",
  d: "M4 12v6H2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2z"
}));

var SvgRegistroTardio = function SvgRegistroTardio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistroTardio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/registro-tardio.5e6942fe.svg";
export { ForwardRef as ReactComponent };